import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsProvider, ISectionProps, Section } from 'telia-front-react';

const Hero = (props: ISectionProps): JSX.Element => {
  return (
    <AnalyticsProvider group="Hero">
      <Section {...props} />
    </AnalyticsProvider>
  );
};

export default observer(Hero);
